export class ErrorModel {
    error: boolean;
    msjError: string;
}